import React from 'react';
import { isAfter } from 'date-fns';
import { Box, Paper, Skeleton, Typography } from '@mui/material';
import { Button, Link } from 'gatsby-theme-material-ui';
import Status from '../Status/Status';
import CalendarIcon from '../../kit/icons/CalendarIcon';
import ClockIcon from '../../kit/icons/ClockIcon';
import { preparePrice } from '../../helpers/lib';
import { styles } from './styles';
import DiscountLabel from '../DiscountLabel/DiscountLabel';

export default function PrecourseCard({
  title,
  isMobile,
  description,
  duration,
  link,
  hours,
  startDate,
  pointsList,
  priceData,
  sendYmEventBuy,
  forDummies = true,
}) {
  const fullPrice = priceData?.fullPrice;
  const discountPrice = priceData?.discountPrice;
  const discountValue =
    5 * Math.round((100 - (discountPrice / fullPrice) * 100) / 5);
  const isDiscount = discountPrice && discountValue > 0;
  const price = isDiscount ? discountPrice : fullPrice;
  return (
    <Paper
      elevation={0}
      sx={{
        ...styles.precourseCardRoot(isMobile),
      }}
    >
      {isMobile && (
        <Typography
          variant="desktopP3Helper"
          color={'kit.text.secondary'}
          component={'div'}
          sx={styles.precourseCardHeader}
        >
          Подготовительная программа
          {forDummies && (
            <Status styleProp={styles.precourseCardStatus}>{`<с нуля>`}</Status>
          )}{' '}
        </Typography>
      )}
      {!isMobile && description && (
        <Typography variant="desktopP1" color={'kit.text.main'}>
          {description}
        </Typography>
      )}
      <Typography
        variant="desktopH4"
        component={'div'}
        color={'kit.text.main'}
        sx={
          description
            ? styles.precourseCardTitle
            : styles.precourseCardTitleNoDescription
        }
      >
        {title}
        {!isMobile && forDummies && (
          <Status styleProp={styles.precourseCardStatus}>{`<с нуля>`}</Status>
        )}
      </Typography>
      <Typography
        variant="desktopP1"
        component={'div'}
        color={'kit.text.main'}
        sx={styles.precourseCardDuration}
      >
        <CalendarIcon color={'#0F0F0F'} sx={styles.precourseCardIcon} />
        {duration}
        {hours && (
          <>
            <ClockIcon color={'#0F0F0F'} sx={styles.precourseCardIcon} />
            {hours}
          </>
        )}
      </Typography>
      <Box sx={{ mt: { xs: 4, lg: 6 } }}>{pointsList}</Box>
      <Typography
        variant={isMobile ? 'desktopP2' : 'desktopP1'}
        component={'div'}
        color={'kit.text.main'}
        sx={styles.precourseCardStart}
      >
        <ClockIcon color={'#0F0F0F'} sx={styles.precourseCardIcon} />
        старт: {startDate || <Skeleton width={100} />}
      </Typography>

      <Typography
        variant={isMobile ? 'desktopP1' : 'desktopH4'}
        component={'div'}
        color={'kit.text.main'}
        sx={styles.precourseCardPrice}
      >
        <Box>
          {isDiscount && (
            <DiscountLabel
              discountValue={discountValue}
              fullPrice={fullPrice}
              size={'small'}
            />
          )}
          {(price && preparePrice(+price) + ' ₽') || (
            <Skeleton width={80} height={30} />
          )}
        </Box>
        <Link underline="none" to={link.url}>
          <Button variant="kitPrimary" size="large" onClick={sendYmEventBuy}>
            {link.title}
          </Button>
        </Link>
      </Typography>
    </Paper>
  );
}
